import { useEffect } from 'react';

import {
  Box,
  Button,
  Chip,
  Container,
  Paper,
  Stack,
  Typography,
} from '@mui/material';

import { useAuth } from './features/auth/AuthProvider.js';
import { LoginPage } from './features/auth/LoginPage.js';
import { ReportDashboard } from './features/reporting/ReportDashboard.js';
import { APP_NAME, APP_TITLE } from './config.js';

const App = () => {
  const { status, source, logout } = useAuth();

  useEffect(() => {
    document.title = APP_TITLE;
  }, []);

  if (status === 'loading') {
    return (
      <Box
        sx={{
          minHeight: '100vh',
          bgcolor: 'background.default',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          p: 4,
        }}
      >
        <Paper sx={{ p: 4 }}>
          <Typography>Načítám stav přihlášení…</Typography>
        </Paper>
      </Box>
    );
  }

  if (status !== 'authenticated') {
    return <LoginPage />;
  }

  return (
    <Box sx={{ minHeight: '100vh', bgcolor: 'background.default', py: 4 }}>
      <Container maxWidth="xl" sx={{ px: { xs: 2, sm: 4 } }}>
        <Stack spacing={4}>
          <Paper
            elevation={0}
            sx={{
              p: 3,
              borderRadius: 3,
              border: '1px solid',
              borderColor: 'divider',
              bgcolor: 'background.paper',
            }}
          >
            <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="space-between" spacing={2}>
              <div>
                <Typography variant="h4" component="h1" fontWeight={600}>
                  {APP_TITLE}
                </Typography>
                <Typography color="text.secondary">
                  {`Výkon Apple Search Ads pro ${APP_NAME}`}
                </Typography>
              </div>
              <Stack direction="row" spacing={2} alignItems="center">
                <Chip
                  color={source === 'allowlist' ? 'success' : 'primary'}
                  label={source === 'allowlist' ? 'Interní síť' : 'Přihlášen'}
                  variant="outlined"
                />
                {source !== 'allowlist' ? (
                  <Button onClick={logout} color="primary">
                    Odhlásit se
                  </Button>
                ) : null}
              </Stack>
            </Stack>
          </Paper>
          <ReportDashboard />
        </Stack>
      </Container>
    </Box>
  );
};

export default App;
